import { render, staticRenderFns } from "./AuthenticationResult.vue?vue&type=template&id=4fe0037e&scoped=true"
import script from "./AuthenticationResult.vue?vue&type=script&lang=js"
export * from "./AuthenticationResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe0037e",
  null
  
)

export default component.exports